import { FC, ReactNode, Suspense, useCallback } from 'react';
import { useTheme } from 'styled-components';

import { ImageComponent } from '../Image';
import { useComponentVisible } from '@/hooks/visibility';

import { ScDashboardPanel } from './styled';

interface DeskDashboardPanel {
  icon?: {
    width: number;
    height: number;
    src: string;
  };
  content?: ReactNode;
  labelText?: string;
  popupContent: ReactNode;
}

export const DeskDashboardPanel: FC<DeskDashboardPanel> = ({
  icon,
  content,
  labelText,
  popupContent,
}) => {
  const { ref, openerRef, isComponentVisible, setIsComponentVisible } =
    useComponentVisible(false);

  const {
    images: {
      arrowDownGrayIcon: { component: ArrowDownGrayIcon },
    },
  } = useTheme();

  const handleClick = useCallback(() => {
    setIsComponentVisible((prev) => !prev);
  }, [setIsComponentVisible]);

  return (
    <ScDashboardPanel
      isOpen={isComponentVisible}
      ref={openerRef}
      onClick={handleClick}
    >
      {content ? (
        content
      ) : (
        <div className="loyalty-panel">
          <b className="level">{labelText}</b>
          <ImageComponent
            height={icon?.height}
            width={icon?.width}
            objectFit="contain"
            src={icon?.src || ''}
            alt="logo"
          />
        </div>
      )}

      <ArrowDownGrayIcon />
      {isComponentVisible && (
        <div className="popup" ref={ref}>
          {popupContent}
        </div>
      )}
    </ScDashboardPanel>
  );
};
